import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

const decode = (status: number, data: ResponseType): unknown => {
    if (status === 200) {
        return;
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface DeleteParamsWithdrawalRuleType {
    id: number;
    accountId: number;
}

export const deleteWithdrawalRule = {
    browser: {
        params: (params: DeleteParamsWithdrawalRuleType): ParamsFetchType<DeleteParamsWithdrawalRuleType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/automatic-withdrawal-rule/delete',
                body: params,
            };
        },
        decode: decode,
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/automatic-withdrawal-rule/delete',
    },
    generateUrlApi: async (
        params: GenerateUrlApiParamsType<DeleteParamsWithdrawalRuleType>
    ): Promise<GenerateUrlApiType> => {
        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                },
            };
        }

        const { id, accountId } = params.req.body;

        const finalUrl = `${params.API_URL}/automatic-withdrawal-rule/${params.API_UNIVERSE}/${accountId}/${id}`;

        return {
            url: finalUrl,
            passToBackend: true,
            method: MethodType.DELETE,
        };
    },
};
